import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Canonical domain: any visit via the legacy OfferReady domain is forwarded
// to the same path on intuiterview.com (safety net alongside registrar-level
// domain forwarding).
if (/(^|\.)theofferready\.com$/i.test(window.location.hostname)) {
  window.location.replace(
    `https://intuiterview.com${window.location.pathname}${window.location.search}${window.location.hash}`
  );
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
